import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/Article/Get', params)
    },
    getList: params => {
        return API.GET('/api/Article/List', params)
    },
    add: params => {
        return API.POST('/api/Article/Publish', params)
    },
    edit: params => {
        return API.POST('/api/Article/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/Article/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/Article/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/article.js